/**
 * [CHANGE_LANGUAGE description]
 * @type {String}
 */
export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE";
export const SET_ENVS = "SET_ENVS";



// WEBPACK FOOTER //
// ./src/actions/types.js